import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import {
  NzNotificationModule,
  NzNotificationService,
} from 'ng-zorro-antd/notification';
import { NzTableModule } from 'ng-zorro-antd/table';
import { HeaderService } from '@/app/common/services/header/header.service';
import { LoaderService } from '@/app/common/services/loader/loader.service';
import { FleetService } from '@/app/modules/fleet/core/service';
import { FleetFindAllParams, FleetVehicle } from '@/app/modules/fleet/core/type';

@Component({
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzButtonModule,
    NzIconModule,
    NzEmptyModule,
    NzNotificationModule,
    NzPaginationModule,
    NzTableModule,
  ],
})
export class FleetListComponent implements OnInit, OnDestroy {
  items: FleetVehicle[] = [];
  total = 0;
  currentPage = 1;
  currentPageSize = 10;
  searchTerm = '';

  constructor(
    private fleetService: FleetService,
    private notification: NzNotificationService,
    private loaderService: LoaderService,
    private headerService: HeaderService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.handleSearchFleet();
    this.headerService.registerAction((searchString) => {
      this.searchTerm = searchString || '';
      return this.handleSearchFleet(1, this.currentPageSize, this.searchTerm);
    }, 'Buscar placa, veículo ou empresa');
  }

  ngOnDestroy(): void {
    this.headerService.removeAction();
  }

  handleSearchFleet(
    pageIndex: number = this.currentPage,
    pageSize: number = this.currentPageSize,
    searchString?: string,
  ): void {
    this.currentPage = pageIndex;
    this.currentPageSize = pageSize;

    if (searchString !== undefined) {
      this.searchTerm = searchString;
    }

    const params = this.buildFindAllParams(pageIndex, pageSize);

    this.loaderService
      .executeWithLoader(this.fleetService.findAll(params))
      .subscribe({
        next: ({ items, total }) => {
          this.items = items;
          this.total = total;
        },
        error: (error: HttpErrorResponse) => {
          this.notification.error(
            `${error.status}`,
            error.error?.message || 'Erro ao carregar a frota.',
          );
        },
      });
  }

  onPageChange(pageIndex: number): void {
    this.handleSearchFleet(pageIndex, this.currentPageSize);
  }

  onPageSizeChange(pageSize: number): void {
    this.handleSearchFleet(1, pageSize);
  }

  clearFilters(): void {
    this.searchTerm = '';
    this.handleSearchFleet(1, this.currentPageSize, '');
  }

  openVehicle(item: FleetVehicle): void {
    this.router.navigate(['/tracker', item.chassis]);
  }

  private buildFindAllParams(
    pageIndex: number,
    pageSize: number,
  ): FleetFindAllParams {
    const params: FleetFindAllParams = { pageIndex, pageSize };
    const term = this.searchTerm.trim();

    if (term && term !== 'undefined') {
      params.searchString = term;
    }

    return params;
  }
}
